import { Container, Row, Col, Modal, Button, Tabs, Tab } from "react-bootstrap";
import "../NewsAndEvents/NewsAndEvents.css";
import { NEWS_AND_EVENTS } from "../../StaticData/NewAndEventsData";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import webinarlogo from "../../assets/images/webinarlogo.png";

const NewsAndEvents = () => {
  const NEWS_Data = [
    {
      date: "July 9, 2026",
      img: webinarlogo,
      newsAndEventsText: "Idexcel Achieves AWS Agentic AI Competency",
      href: "/news/idexcel-achieves-aws-agentic-ai-competency",
    },
    {
      date: "January 20, 2026",
      img: webinarlogo,
      newsAndEventsText: "Idexcel Achieves AWS Generative AI Services Competency",
      href: "/news/idexcel-achives-aws-generative-ai-competency",
    },

  ];

  const [showModal, setShowModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [activeTab, setActiveTab] = useState("events");

  const handleShow = (url) => {
    setVideoUrl(url);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setVideoUrl("");
  };

  return (
    <div className="news-and-events-page">
      <Helmet>
        <title> News and Events | Idexcel </title>
        <meta
          content="idexcel latest news, idexcel latest events, aws events, cloud computing events"
          name="keywords"
        />
        <meta
          content="Read to know more about Idexcel latest news and events."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="news-banner-container p-0">
          <section className="news-banner-section"></section>
        </Container>
      </motion.div>

      <section className="news-and-events-section">
        <Container className="my-5 px-xl-5">
          <h2 className="text-center mb-4 section-title">
            News and <span className="textgrad"> Events</span>{" "}
          </h2>
          <Tabs
            id="news-and-events-tabs"
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3 "
            style={{ borderBottom: "2px solid #ddd" }}
          >
            <Tab
              eventKey="events"
              title="Events"
              tabClassName={activeTab === "events" ? "active-tab" : ""}
            >
              <h3 className="text-center mb-5 grey-text">Events</h3>
              <section className="px-xl-5">
                <Row className="m-0 p-0 mb-5 mb-lg-0 mb-md-0 d-flex">
                  {NEWS_AND_EVENTS?.map((newsandevent, index) => {
                    const isLastItem = index === NEWS_AND_EVENTS.length - 1;
                    return (
                      <div
                        key={index}
                        className={`m-0 px-2 px-md-0 px-lg-4 case d-flex flex-column flex-md-row flex-lg-row align-items-start mb-2 mb-lg-3 mb-md-3 pb-3 pb-md-0 ${isLastItem ? "" : "border-bottom"
                          }`}
                      >
                        {/* Date Column */}
                        <div className="col-5 col-lg-2 col-md-2 p-0 mt-3">
                          <p style={{ fontSize: "15px" }}>
                            {newsandevent?.date}
                          </p>
                        </div>

                        <div className="d-flex flex-md-row flex-lg-row flex-column align-items-lg-center">
                          {/* Image Column */}
                          <div className="p-2 img-wrap d-flex mb-4 justify-content-center align-items-center">
                            <div className="news-badge">
                              Webinar
                            </div>
                          </div>
                          {/* News and Event Text Column with Link */}
                          <div className="p-2 px-0 px-lg-3 px-md-3 mb-0 mb-lg-3 mb-md-3">
                            <p
                              className="mb-1 fs-5 text-black fw-semibold"
                              style={{ lineHeight: "1.2" }}
                            >
                              {newsandevent?.newsAndEventsText}
                            </p>
                            {/* Show Visit Website if URL exists */}
                            {newsandevent?.websiteUrl ? (
                              <Button
                                variant="link"
                                className="textDecoration px-0"
                                onClick={() => window.open(newsandevent.websiteUrl, "_blank")}
                              >
                                Read More
                              </Button>
                            ) : (
                              /* Otherwise show Watch Video */
                              <Button
                                variant="link"
                                className="textDecoration px-0"
                                onClick={() => handleShow(newsandevent?.newseventsvideo)}
                              >
                                Watch Video
                              </Button>
                            )}


                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Row>
              </section>
            </Tab>
            <Tab
              eventKey="news"
              title="News"
              tabClassName={activeTab === "news" ? "active-tab" : ""}
            >
              <h3 className="text-center mb-5 grey-text">News</h3>
              <section className="px-xl-5">
                <Row className="m-0 p-0 mb-5 mb-lg-0 mb-md-0 d-flex">
                  {NEWS_Data?.map((news, index) => {
                    const isLastItem = index === NEWS_Data.length - 1;
                    return (
                      <div
                        key={index}
                        className={`m-0 px-2 px-md-0 px-lg-4 case d-flex flex-column flex-md-row flex-lg-row align-items-start mb-2 mb-lg-3 mb-md-3 pb-3 pb-md-0 ${isLastItem ? "" : "border-bottom"
                          }`}
                      >
                        {/* Date Column */}
                        <div className="col-5 col-lg-2 col-md-2 p-0 mt-3">
                          <p style={{ fontSize: "15px" }}>{news.date}</p>
                        </div>

                        <div className="d-flex flex-md-row flex-lg-row flex-column align-items-lg-center">
                          {/* Image Column */}
                          <div className="p-2 img-wrap d-flex justify-content-center align-items-center ">
                            <div className="news-badge">
                              News
                            </div>
                          </div>

                          {/* News Text + Read More */}
                          <div className="p-2 px-0 px-lg-3 px-md-3 mb-0 mb-lg-3 mb-md-3">
                            <p
                              className="mb-1 fs-5 text-black fw-semibold"
                              style={{ lineHeight: "1.2" }}
                            >
                              {news.newsAndEventsText}
                            </p>

                            <Button
                              variant="link"
                              className="textDecoration px-0"
                              onClick={() => (window.location.href = news.href)}
                            >
                              Read More
                            </Button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Row>
              </section>
            </Tab>
            {/* {false && (
              <Tab
                eventKey="news"
                title="News"
                disabled
                tabClassName="disabled-tab"
              >
                <p className="text-center mt-5">
                  News content is currently unavailable.
                </p>
              </Tab>
            )} */}
          </Tabs>
        </Container>
      </section>

      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        className="custom-modal"
      >
        <Modal.Body className="custom-modal-body">
          <Button
            variant="close"
            onClick={handleClose}
            aria-label="Close"
            className="custom-close-button"
          >
            <span aria-hidden="true">&times;</span>
          </Button>
          <div className="embed-responsive embed-responsive-16by9">
            <iframe
              className="embed-responsive-item"
              src={videoUrl}
              // allowFullScreen
              title="Event Video"
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default NewsAndEvents;
